/* =============================================================
   Vivo color-image grouping  (no ALT text, no metafields)

   Shows ONLY the selected color's gallery images, on EVERY layout:
     - stack / grid  -> simple show/hide
     - thumbnail-left / bottom / hidden (slider) -> toggle slides
       and refresh the theme's Swiper so there are no gaps

   Derives which image belongs to which color from data already on
   the page: each color variant's assigned image position (variant
   JSON) + the gallery's existing color-ordered image order.

   Pure show/hide layer. Never changes variants, cart, or checkout.
   Fails safe: if it can't confidently group, it shows everything.
   ============================================================= */
(function () {
  'use strict';

  function parseVariants() {
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      var data;
      try { data = JSON.parse(scripts[i].textContent); } catch (e) { continue; }
      if (Array.isArray(data) && data.length && data[0] &&
          ('option1' in data[0]) && ('featured_image' in data[0] || 'featured_media' in data[0])) {
        return data;
      }
    }
    return null;
  }

  function imgPosition(v) {
    if (v.featured_image && typeof v.featured_image.position === 'number') return v.featured_image.position;
    if (v.featured_media && typeof v.featured_media.position === 'number') return v.featured_media.position;
    return null;
  }

  function buildColorPositions(variants, colorValues) {
    var map = {};
    colorValues.forEach(function (color) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.option1 === color || v.option2 === color || v.option3 === color) {
          var pos = imgPosition(v);
          if (pos != null) { map[color] = pos; break; }
        }
      }
    });
    return map;
  }

  function colorFieldset(root) { return root.querySelector('fieldset.product-form__input_color'); }

  function colorValuesFrom(fs) {
    var vals = [];
    fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
      if (inp.value && vals.indexOf(inp.value) === -1) vals.push(inp.value);
    });
    return vals;
  }

  function selectedColor(fs) {
    var c = fs.querySelector('input[type="radio"]:checked');
    return c ? c.value : null;
  }

  function mediaKey(el) { return el.getAttribute('data-media-id') || ''; }

  function setup(root) {
    if (root.__vivoColorInit) return;

    var fs = colorFieldset(root);
    if (!fs) return;

    var variants = parseVariants();
    if (!variants) return;

    var colorValues = colorValuesFrom(fs);
    if (colorValues.length < 2) return;

    var colorPos = buildColorPositions(variants, colorValues);
    var anchors = Object.keys(colorPos).map(function (c) { return { color: c, pos: colorPos[c] }; });
    if (anchors.length < 2) return;
    anchors.sort(function (a, b) { return a.pos - b.pos; });

    var mediaScope = root.querySelector('.product-detail__media') || root;
    var slideEl = mediaScope.querySelector('slide-with-thumbs');
    var mainSwiper = mediaScope.querySelector('.media-main-swiper');
    var observer = null;

    root.__vivoColorInit = true;

    function ownerForPosition(pos) {
      var owner = null;
      for (var a = 0; a < anchors.length; a++) {
        if (pos >= anchors[a].pos) owner = anchors[a].color; else break;
      }
      return owner || '__shared__';
    }

    /* Build media-id -> color from the MAIN ordered list (avoids counting
       thumbnail duplicates twice). */
    function keyColorMap() {
      var primary = mainSwiper
        ? [].slice.call(mainSwiper.querySelectorAll('.media-gallery__image'))
        : [].slice.call(mediaScope.querySelectorAll('.media-gallery__image'));
      var map = {};
      primary.forEach(function (el, idx) { map[mediaKey(el)] = ownerForPosition(idx + 1); });
      return map;
    }

    function apply() {
      var map = keyColorMap();
      var color = selectedColor(fs) || anchors[0].color;
      var items = [].slice.call(mediaScope.querySelectorAll('.media-gallery__image'));
      if (!items.length) return;

      if (observer) observer.disconnect();

      items.forEach(function (el) {
        var owner = map[mediaKey(el)];
        var show = (owner === undefined) || owner === color || owner === '__shared__';
        el.style.display = show ? '' : 'none';
        /* for slider layouts, add/remove swiper-slide so Swiper skips hidden ones */
        if (el.dataset.vivoSlide === undefined) {
          el.dataset.vivoSlide = el.classList.contains('swiper-slide') ? '1' : '0';
        }
        if (el.dataset.vivoSlide === '1') {
          el.classList.toggle('swiper-slide', show);
        }
      });

      if (slideEl) {
        try { slideEl.updateSlide && slideEl.updateSlide(); } catch (e) {}
        try { slideEl.updateThumbSlide && slideEl.updateThumbSlide(); } catch (e) {}
        try { if (slideEl.globalSlide) { slideEl.globalSlide.update(); slideEl.globalSlide.slideTo(0, 0); } } catch (e) {}
        try { if (slideEl.thumbnailSlide) { slideEl.thumbnailSlide.update(); } } catch (e) {}
      }

      reconnect();
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; apply(); });
    }

    function reconnect() {
      try {
        if (!observer) observer = new MutationObserver(schedule);
        observer.observe(mediaScope, { childList: true, subtree: true });
      } catch (e) {}
    }

    fs.addEventListener('change', function () { requestAnimationFrame(apply); });
    /* theme rebuilds media async on some layouts; re-apply shortly after a color click */
    root.addEventListener('click', function (e) {
      if (e.target.closest('fieldset.product-form__input_color')) {
        setTimeout(apply, 60);
        setTimeout(apply, 300);
      }
    });

    apply();
  }

  function init() {
    var roots = document.querySelectorAll('.product__item-js');
    if (roots.length) { roots.forEach(setup); return; }
    var m = document.querySelector('.product-detail__media');
    if (m) setup(m.closest('section') || document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
